import React from "react";

interface AlertIconProps {
  size?: number;
  className?: string;
}

export const AlertIcon: React.FC<AlertIconProps> = ({
  size = 64,
  className,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64" // Using a 64x64 viewBox for consistency
      width={size}
      height={size}
      className={className} // Allows external styling
    >
      {/* Red Circle Background */}
      <circle cx="32" cy="32" r="30" fill="#FF0000" />

      {/* White Exclamation Mark */}
      {/* Main vertical bar of the exclamation mark */}
      <rect x="28" y="12" width="8" height="28" rx="3" ry="3" fill="#FFFFFF" />
      {/* Dot of the exclamation mark */}
      <circle cx="32" cy="48" r="4" fill="#FFFFFF" />
    </svg>
  );
};
